export function createMask() {
  const element = document.createElement('div');
  element.classList.add('ctrl-mask');
  return element;
}

export const options = {
  revealAnimation: 'fade-in',
  revealAnimationSpeed: 'fast',
  revealAnimationTiming: 'ease-in-out',
  mask: false,
  blurCanvas: false,
  greyscaleCanvas: false,
  style: {
    normal: {
      zIndex: 700,
    },
  },
};
